import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {BlueprintSummaryRoutingModule} from './blueprint-summary-routing.module';
import {BlueprintSummaryComponent} from './blueprint-summary.component';
import {SharedModule} from '../../../shared/shared.module';
import {BreadcrumbModule} from '../../../components/breadcrumb/breadcrumb.module';
import {IconsModule} from '../../../icons/icons.module';
import {PipesModule} from '../../../pipes/pipes.module';
import {MatMenuModule} from '@angular/material/menu';
import {ViewEndpointsModule} from '../view-endpoints/view-endpoints.module';
import {AutoUpdateInfoModule} from '../auto-update-info/auto-update-info.module';
import {PageLoaderModule} from 'src/app/components/page-loader/page-loader.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UpdateConfigurationModule} from 'src/app/main/service/update-configuration/update-configuration.module';
import {RequestUpdateConfigurationModule} from 'src/app/main/service/request-update-configuration/request-update-configuration.module';
import {FormsModule} from '@angular/forms';
import {ReportIssueModule} from 'src/app/main/service/report-issue/report-issue.module';
import {DeployInstanceModule} from 'src/app/main/service/deploy-instance/deploy-instance.module';
import {ConfirmationDialogModule} from 'src/app/components/confirmation-dialog/confirmation-dialog.module';
import {
  RequestDeployInstanceDialogModule
} from 'src/app/main/service/request-deploy-instance-dialog/request-deploy-instance-dialog.module';
import {
  ConfirmDeployInstanceDialogModule
} from 'src/app/main/service/confirm-deploy-instance-dialog/confirm-deploy-instance-dialog.module';
import {ConfigurationStateModule} from 'src/app/main/service/configuration-state/configuration-state.module';
import {ViewUpdateResultsModule} from 'src/app/main/service/view-update-results/view-update-results.module';
import {MatDividerModule} from '@angular/material/divider';
import { ViewServiceDefinitionVersionDetailsModule }
from 'src/app/components/view-service-definition-version-details/view-service-definition-version-details.module';
import {ViewCapabilityCardModule} from 'src/app/components/view-capability-card/view-capability-card.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {UpdateDefinitionModule} from '../update-definition/update-definition.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import { SecretModule } from 'src/app/components/secret/secret.module';
import {VerifypopupModule} from 'src/app/components/verifypopup/verifypopup.module';
import { SkiptestPopupModule } from 'src/app/components/skiptest-popup/skiptest-popup.module';
import { InstanceDetailsComponent } from './instance-details/instance-details.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatTabsModule } from '@angular/material/tabs';
import { InstanceApplyConfigurationModule } from '../instance-apply-configuration/instance-apply-configuration.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { GenericErrorModule } from 'src/app/components/generic-error/generic-error.module';
import { InstanceExecuteRvtModule } from '../instance-execute-rvt/instance-execute-rvt.module';
import { ConfigDialogLiveComponentModule } from 'src/app/components/config-dialog-live-component/config-dialog-live-component-module';
@NgModule({
  declarations: [
    BlueprintSummaryComponent,
    InstanceDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    PipesModule,
    BreadcrumbModule,
    UpdateConfigurationModule,
    RequestUpdateConfigurationModule,
    ViewEndpointsModule,
    AutoUpdateInfoModule,
    PageLoaderModule,
    ReportIssueModule,
    DeployInstanceModule,
    RequestDeployInstanceDialogModule,
    ConfirmDeployInstanceDialogModule,
    ConfirmationDialogModule,
    ConfigurationStateModule,
    ViewUpdateResultsModule,
    UpdateDefinitionModule,
    BlueprintSummaryRoutingModule,
    MatTooltipModule,
    MatMenuModule,
    FormsModule,
    MatDividerModule,
    ViewServiceDefinitionVersionDetailsModule,
    ViewCapabilityCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatChipsModule,
    SecretModule,
    VerifypopupModule,
    SkiptestPopupModule,
    ClipboardModule,
    NgxSkeletonLoaderModule,
    MatTabsModule,
    InstanceApplyConfigurationModule,
    PaginatorModule,
    SearchFilterModule,
    GenericErrorModule,
    InstanceExecuteRvtModule,
    ConfigDialogLiveComponentModule
  ]
})
export class BlueprintSummaryModule { }
